import { FullFormState } from "../../Engine/Core/Store/FullFormState";
import { getIn, setIn, deleteIn } from "../ReduxStateHelpers";
import { UnitId, unitIdToLegacyUnitId } from "../../Controls/FormParts/Unit/UnitId/UnitId";

export class UnitStateSelect {
    public static getUnitWidth(state: FullFormState, unitId: UnitId): number | undefined {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return getIn(state, ["units", unitIdToLegacyUnitId(unitId), "width"]);
    }

    public static setUnitWidth(state: FullFormState, unitId: UnitId, width: number): FullFormState {
        return setIn(state, ["units", unitIdToLegacyUnitId(unitId), "width"], width);
    }

    public static deleteUnitWidth(state: FullFormState, unitId: UnitId): FullFormState {
        return deleteIn(state, ["units", unitIdToLegacyUnitId(unitId)], "width");
    }

    public static getUnitTableWidths(state: FullFormState, unitId: UnitId): { [key: string]: number } {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return getIn(state, ["units", unitIdToLegacyUnitId(unitId), "tablesWidth"], {});
    }

    public static setUnitTableWidth(
        state: FullFormState,
        unitId: UnitId,
        tableId: string,
        width: number
    ): FullFormState {
        return setIn(state, ["units", unitIdToLegacyUnitId(unitId), "tablesWidth", tableId], width);
    }

    public static deleteUnitTableWidth(state: FullFormState, unitId: UnitId, tableId: string): FullFormState {
        return deleteIn(state, ["units", unitIdToLegacyUnitId(unitId), "tablesWidth"], tableId);
    }
}
